export type SellerProfilePayload = {
    display_name: string;
    phone: string;
    email_public: string;
    description: string;
    address_street: string;
    address_city: string;
    address_voivodeship: string;
    address_postal: string;
    logo_url: string;
    logo_key: string;
    cover_url: string;
    cover_key: string;
    /** Server-owned public slug; read-only in panel when present. */
    slug?: string;
};

export const emptySellerProfile = (): SellerProfilePayload => ({
    display_name: "",
    phone: "",
    email_public: "",
    description: "",
    address_street: "",
    address_city: "",
    address_voivodeship: "",
    address_postal: "",
    logo_url: "",
    logo_key: "",
    cover_url: "",
    cover_key: ""
});

export const normalizeSellerProfile = (raw: Partial<SellerProfilePayload> | null | undefined): SellerProfilePayload => {
    const base = emptySellerProfile();
    if (!raw || typeof raw !== "object") {
        return base;
    }
    return {
        display_name: String(raw.display_name || ""),
        phone: String(raw.phone || ""),
        email_public: String(raw.email_public || ""),
        description: String(raw.description || ""),
        address_street: String(raw.address_street || ""),
        address_city: String(raw.address_city || ""),
        address_voivodeship: String(raw.address_voivodeship || ""),
        address_postal: String(raw.address_postal || ""),
        logo_url: String(raw.logo_url || ""),
        logo_key: String(raw.logo_key || ""),
        cover_url: String(raw.cover_url || ""),
        cover_key: String(raw.cover_key || ""),
        slug: raw.slug ? String(raw.slug) : undefined
    };
};
